/* ============================================================
   Aisha Club - Redesign: Minicart OPTIMISTIC UPDATE layer
   ------------------------------------------------------------
   Sorun: tema her adet +/- / kaldir isleminde /cart/change.js'e gidip
   section'i yeniden render ediyor (300ms debounce + sunucu round-trip).
   shopify theme dev'de bu ~2sn -> "fiyat hizlica degismiyor".
   Cozum: tiklama aninda ara toplam + sayaci client-side guncelle;
   tema'nin debounce'lu sunucu cevabi arka planda dogrular (overwrite).
   Vendor JS'e DOKUNULMAZ. Geri-alinabilir: bu dosya + theme.liquid'deki
   <script> satiri kaldirilinca tema varsayilan davranisina doner.
   Not: kademeli (quantity-based) indirimlerde anlik tahmin, sunucu
   cevabiyla netlesir (kisa duzeltme olabilir) - bilinen tradeoff.
   ============================================================ */
(function () {
  'use strict';

  // "8,197.50TL" / "₺8.197,50" -> 8197.5  (gosterilen formati anlayan ayristirici)
  function parseMoney(str) {
    if (!str) return NaN;
    var m = String(str).match(/[\d.,]+/);
    if (!m) return NaN;
    var core = m[0];
    var hasC = core.indexOf(',') > -1, hasD = core.indexOf('.') > -1, dec = '.';
    if (hasC && hasD) dec = core.lastIndexOf('.') > core.lastIndexOf(',') ? '.' : ',';
    else if (hasC) dec = (core.split(',').pop().length === 2) ? ',' : '.';
    else if (hasD) dec = (core.split('.').pop().length === 2) ? '.' : '.';
    var norm = dec === ',' ? core.replace(/\./g, '').replace(',', '.') : core.replace(/,/g, '');
    var v = parseFloat(norm);
    return isNaN(v) ? NaN : v;
  }

  // sample stringin formatini (prefix/suffix, ayraclar, ondalik) koruyarak value'yu bicimle
  function formatLike(sample, value) {
    var m = String(sample).match(/[\d.,]+/);
    if (!m) return sample;
    var core = m[0];
    var prefix = String(sample).slice(0, m.index);
    var suffix = String(sample).slice(m.index + core.length);
    var hasC = core.indexOf(',') > -1, hasD = core.indexOf('.') > -1;
    var thousands = ',', decimal = '.';
    if (hasC && hasD) {
      if (core.lastIndexOf('.') > core.lastIndexOf(',')) { thousands = ','; decimal = '.'; }
      else { thousands = '.'; decimal = ','; }
    } else if (hasC) {
      if (core.split(',').pop().length === 2) { decimal = ','; thousands = '.'; }
      else { thousands = ','; decimal = '.'; }
    }
    var dpart = core.split(decimal)[1];
    var decimals = dpart ? dpart.length : 0;
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var num = decimals > 0 ? ip + decimal + parts[1] : ip;
    return prefix + num + suffix;
  }

  function adjustSubtotal(delta) {
    document.querySelectorAll('[data-cart-subtotal-price]').forEach(function (el) {
      var cur = parseMoney(el.textContent);
      if (isNaN(cur)) return;
      var next = cur + delta;
      if (next < 0) next = 0;
      el.textContent = formatLike(el.textContent, next);
    });
  }

  function currentCount() {
    var d = document.querySelector('.cart-count-drawer') ||
            document.querySelector('.header__minicart .cart-count');
    if (!d) return null;
    var mm = d.textContent.match(/\d+/);
    return mm ? parseInt(mm[0], 10) : null;
  }

  function adjustCount(delta) {
    var cur = currentCount();
    if (cur === null) return;
    var n = cur + delta;
    if (n < 0) n = 0;
    document.querySelectorAll('.cart-count-drawer').forEach(function (el) {
      el.textContent = ' (' + n + ') ';
    });
    // header bubble: sadece bastaki sayi text-node'unu degistir (visually-hidden span korunur)
    document.querySelectorAll('.header__minicart .cart-count').forEach(function (el) {
      var label = n > 99 ? '~' : String(n);
      if (el.firstChild && el.firstChild.nodeType === 3) el.firstChild.textContent = label;
      else el.insertBefore(document.createTextNode(label), el.firstChild);
    });
  }

  function unitPriceOf(item) {
    var p = item.querySelector('.minicart__item-price');
    return p ? parseMoney(p.textContent) : NaN;
  }
  function qtyOf(item) {
    var inp = item.querySelector('.quantity-input');
    var q = inp ? parseInt(inp.value, 10) : 1;
    return isNaN(q) ? 1 : q;
  }

  // capture fazi: temanin quantity-input decrement'inden ONCE calisir -> qty pre-click okunur
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest('.minicart')) return;
    var item = t.closest('.cart-item');
    if (!item) return;

    var isPlus = !!t.closest('[name="plus"]');
    var isMinus = !!t.closest('[name="minus"]');
    var isRemove = !!t.closest('.cart-remove, mini-cart-remove-button, .minicart__item-remove');
    if (!isPlus && !isMinus && !isRemove) return;

    var unit = unitPriceOf(item);
    if (isNaN(unit)) return;

    if (isPlus) {
      adjustSubtotal(+unit); adjustCount(+1);
    } else if (isMinus) {
      if (qtyOf(item) <= 0) return;
      adjustSubtotal(-unit); adjustCount(-1);
    } else if (isRemove) {
      var q = qtyOf(item);
      adjustSubtotal(-unit * q); adjustCount(-q);
    }
  }, true);
})();
